import { OfferingFileFragment } from 'graphql/bindings/AdminBindings'

export const download = (file: OfferingFileFragment) => {
  window.open(JSON.parse(file.url).url)
}
